/* eslint react-hooks/exhaustive-deps: "warn" */

import { useState } from 'react';

import cn from 'classnames';

import styles from './ConnectorChatCard.module.scss';

import type { ConnectorChatCardProps } from './ConnectorChatCard.types';

type Assistant = 'claude' | 'gpt';

const ASSISTANTS: { key: Assistant; label: string; glyph: string }[] = [
  { key: 'claude', label: 'Claude', glyph: '✳' },
  { key: 'gpt', label: 'ChatGPT', glyph: '◈' },
];

export const ConnectorChatCard = ({ className }: ConnectorChatCardProps) => {
  const [ai, setAi] = useState<Assistant>('claude');

  const active = ASSISTANTS.find((a) => a.key === ai) ?? ASSISTANTS[0];

  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.top}>
        <div className={styles.switch} role="tablist" aria-label="Choose assistant">
          {ASSISTANTS.map((a) => (
            <button
              key={a.key}
              type="button"
              role="tab"
              aria-selected={a.key === ai}
              className={cn(a.key === ai && styles.on)}
              onClick={() => setAi(a.key)}
            >
              {a.glyph} {a.label}
            </button>
          ))}
        </div>

        <span className={styles.conn}>● Global Database connected</span>
      </div>

      <div className={styles.user}>
        <span>Which companies is Martin Kessler connected to?</span>
      </div>

      <div className={styles.tool}>
        <span className={styles.gear} aria-hidden="true">
          ⚙
        </span>
        <span>
          <b>Global Database connector</b> · person_ownership(&quot;Martin Kessler&quot;)
        </span>
      </div>

      <div className={styles.bot}>
        <span className={cn(styles.avatar, ai === 'gpt' && styles.avatarGpt)} aria-hidden="true">
          {active.glyph}
        </span>

        <div className={styles.msg}>
          Martin Kessler holds <b>6 positions across 3 countries</b> — he is a PSC of <b>Kessler Group Holdings Ltd</b>{' '}
          with a <b>52.4% stake</b>, and a director of Kessler Trading Ltd, Kessler Travel Ltd and 3 more.
          <div className={styles.src}>
            <span className={styles.pill}>Companies House · PSC register</span>
            <span>Filed 14 May 2026</span>
          </div>
        </div>
      </div>

      <div className={styles.ask}>
        <input
          type="text"
          placeholder="Ask about any company or person…"
          aria-label="Ask about any company or person"
          readOnly
        />
        <button type="button" className={styles.send} aria-label="Send">
          ↑
        </button>
      </div>
    </div>
  );
};
